<template>
  <div class="bg-f8f8f8">
    <div class="pb-12 pt-28 bg-white px-16">
      <div class="flex">
        <div class="w-1/4">
          <b-card class="cardbody-p rounded-xl">
            <div
              class="flex items-center cursor-pointer p-2 mb-3"
              v-for="(item, index) in menus"
              :key="'item-' + index"
              @click="handleClick(item)"
              :class="{
                'bg-f4f5f6 text-white rounded-lg':
                  item.route === currentRoute.currentRoute.name,
              }"
            >
              <!-- :class="{
                'bg-ededed text-white rounded-lg':
                  item.route === currentRoute.currentRoute.name
              }" -->
              <!-- <feather-icon
                :icon="item.icon"
                class="cursor-pointer p-3 text-primary"
                :class="{
                  ' text-primary': item.route === currentRoute.currentRoute.name
                }"
              ></feather-icon> -->
              <feather-icon
                :icon="item.icon"
                class="cursor-pointer p-3 text-primary"
                :class="{
                  ' text-primary':
                    item.route === currentRoute.currentRoute.name,
                }"
              ></feather-icon>

              <div class="ml-2">
                <p
                  class="font-semibold text-lg"
                  :class="{
                    ' text-primary':
                      item.route === currentRoute.currentRoute.name,
                  }"
                >
                  {{ item.text }}
                </p>
              </div>
            </div>
          </b-card>
        </div>

        <div class="w-3/4 pl-3">
          <!-- <zoom-center-transition>     </zoom-center-transition> -->
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../scss/Index.scss";
import { ZoomCenterTransition } from "vue2-transitions";
export default {
  data() {
    return {
      menus: [
        // {
        //   icon: "HomeIcon",
        //   text: "Dashboard",
        //   route: "social-admin-home"
        // },
        // {
        //   icon: "UserIcon",
        //   text: "Users",
        //   route: "social-admin-addbanner"
        // },
        // {
        //   icon: "HeartIcon",
        //   text: "Community",
        //   route: "social-admin-addcategory"
        // },
        // {
        //   icon: "TagIcon",
        //   text: "Posts",
        //   route: "social-admin-addtags"
        // },
        // {
        //   icon: "UsersIcon",
        //   text: "Communications",
        //   route: "social-admin-campaign"
        // },
        // {
        //   icon: "UserIcon",
        //   text: "Integration",
        //   route: "social-admin-integration"
        // },
        {
          icon: "BookIcon",
          text: "Blogs",
          route: "social-admin-blog",
        },
        {
          icon: "FileTextIcon",
          text: "Tag",
          route: "social-admin-tag",
        },

        // {
        //   icon: "BookIcon",
        //   text: "Add Category",
        //   route: "social-admin-addcategory"
        // },
        // {
        //   icon: "FileTextIcon",
        //   text: "Add Page",
        //   route: "social-admin-page"
        // },
        // {
        //   icon: "MenuIcon",
        //   text: "Add Menu",
        //   route: "social-admin-menu"
        // },
        // {
        //   icon: "UserIcon",
        //   text: "Taxes",
        //   route: "social-admin-taxes"
        // },

        // {
        //   icon: "BarChart2Icon",
        //   text: "Analytics",
        //   route: "social-admin-reports"
        // }
      ],
      pageTransitionDuration: 200,
    };
  },

  computed: {
    currentRoute() {
      return this.$router;
    },
  },
  components: {
    ZoomCenterTransition,
  },
  methods: {
    handleClick({ route }) {
      this.$router.push({ name: route });
    },
  },
};
</script>
